import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import Typography from '../../base/Typography';
import Button from '../../base/Button';
import Picture from '../../base/Picture';
import { Row, Col } from '../../base/Grid';
import './dynamic-callout.scss';

const buttonTextDefault = 'Get started';
const jsRedirect = (urlPath) => {
  window.location.replace(urlPath);
};

export const DynamicCalloutComponent = ({
  orientation,
  imageId,
  image,
  imageAlt,
  title,
  buttonText,
  url,
  tag,
}) => {
  // card CTA orientation
  if (orientation === 'card') {
    return (
      <div className="dynamic-callout dynamic-callout--card nmx-base">
        <article id="" className="dynamic-callout__article">
          <a className="dynamic-callout__article-container" href={url}>
            <span className="dynamic-callout__article-tag">
              <Typography
                component="p"
                color="#0e497b"
                disableBottomPadding>
                {tag}
              </Typography>
            </span>
            <Picture variant="primary" src={image} alt={imageAlt}></Picture>
            <div className="dynamic-callout__content-container">
              <Typography
                component="h3"
                variant="h5"
                color="#4a4a4a"
                disableBottomPadding>
                {title}
              </Typography>
            </div>
          </a>
        </article>
      </div>
    );
  }
  // default to Banner orientation
  useEffect(() => {
    // Grab image path from props and pass it in as a BG image for the banner orientation
    document.getElementById(imageId).style.backgroundImage = `url(${image})`;
    const innerButton = document.getElementById('dynamic-callout-button');
    const bannerOverlay = document.getElementById(
      'dynamic-callout-banner-overlay',
    );
    bannerOverlay.addEventListener('mouseenter', () => {
      innerButton.classList.add('is-active');
    });
    bannerOverlay.addEventListener('mouseleave', () => {
      innerButton.classList.remove('is-active');
    });
  }, []);

  return (
    <div className="dynamic-callout dynamic-callout--banner nmx-base">
      <Row align="center">
        <Col className="nmx-col-nested" xsmall={12} medium={3} large={3}>
          <div className="dynamic-callout__image-container" id={imageId} />
        </Col>
        <Col xsmall={12} medium={5} large={6}>
          <div className="dynamic-callout__content-container">
            {/* TODO: Update the color value to hex once the recent typography updates come through */}
            <Typography
              // weight={400}
              component="h4"
              variant="h5"
              align="left"
              color={'#4a4a4a'}
              disableBottomPadding>
              {title}
            </Typography>
          </div>
        </Col>
        <Col xsmall={12} medium={4} large={3}>
          <div className="dynamic-callout__button-container">
            <Button
              role="link"
              variant="tertiary"
              transparent={true}
              id="dynamic-callout-button"
              onClick={(e) => {
                jsRedirect(url);
              }}>
              {buttonText || buttonTextDefault}
            </Button>
          </div>
        </Col>
      </Row>
      {/* Clickable overlay for the banner variation */}
      <button
        role="link"
        id="dynamic-callout-banner-overlay"
        className="dynamic-callout__overlay"
        onClick={(e) => {
          jsRedirect(url);
        }}
      />
    </div>
  );
};

DynamicCalloutComponent.propTypes = {
  orientation: PropTypes.string,
  imageId: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  url: PropTypes.string.isRequired,
  tag: PropTypes.string,
};

export default withTheme(DynamicCalloutComponent);
